export default "__VITE_ASSET__BT3Cs4Rm__"